import React from "react";

const MailIcons = ({ provider }) => {
  return (
    <div>
      {provider === "google" && (
        <img
          src="/ee-static/members/images/gmail.svg"
          alt="gmail"
          style={{ height: "1.1rem" }}
        />
      )}
      {provider === "outlook" && (
        <img
          src="/ee-static/members/images/outlook.svg"
          alt="outlook"
          style={{ height: "1.1rem" }}
        />
      )}
      {provider === "apple" && (
        <img
          src="/ee-static/members/images/apple.svg"
          alt="apple"
          style={{ height: "1.1rem" }}
        />
      )}
      {provider === "yahoo" && (
        <img
          src="/ee-static/members/images/yahoo.svg"
          alt="yahoo"
          style={{ height: "1.1rem" }}
        />
      )}
    </div>
  );
};

export default MailIcons;
